import { render, staticRenderFns } from "./NewOrders.vue?vue&type=template&id=8ad687e4&scoped=true"
import script from "./NewOrders.vue?vue&type=script&lang=js"
export * from "./NewOrders.vue?vue&type=script&lang=js"
import style0 from "./NewOrders.vue?vue&type=style&index=0&id=8ad687e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad687e4",
  null
  
)

export default component.exports